import {InputImage, ProcessedResult} from "../types";

export abstract class ImagebProcesser {


  abstract process(input: InputImage): ProcessedResult;
}

